import React from 'react';
import { useTranslation } from 'react-i18next';
import Vale from '../Vales';

const ValesPreActivados = ({
  valesPreAct,
  retrieveValesAhorro,
  isMobile,
  setVisible,
  setPromocion,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="divider" />
      <div className="listado-vales">
        <h2 className="bloque-datos__title u-text-brand">
          <span className="divider__square brand-color" />
          <span className="u-margin-right">{t('vales.preactivados')}</span>
        </h2>
        <div className="listado-vales__filtro" />
      </div>

      <div className="listado-vales-promociones listado-vales__activos">
        {valesPreAct &&
          valesPreAct.map((valeData, index) => (
            <Vale
              setPromocion={setPromocion}
              preActivado
              key={`vale-${valeData.valeEAN}`}
              data={valeData}
              cargarVales={retrieveValesAhorro}
              valeIndex={isMobile ? 0 : index}
              showCondLegales={setVisible}
            />
          ))}
      </div>
    </>
  );
};

export default ValesPreActivados;
